export default "__VITE_ASSET__8ca60df2__"